/* eslint-disable arrow-body-style */
import { Alert, AlertTitle } from '@mui/material';
import { useLocalization } from '../../providers/LocalizationProvider';

function FormStateError({ errors }) {
  const { formatMessage } = useLocalization();

  // Collect all error messages (including nested ones)
  const collectErrors = (errorsObj, prefix = '', idx = 0) => {
    let messages = [];

    Object.entries(errorsObj || {}).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // For field arrays
        value.forEach((v, i) => {
          const collectedErrors = collectErrors(
            v,
            `${prefix}${key}[${i}].`,
            i + 1,
          );
          messages = [...messages, ...collectedErrors];
        });
      } else if (typeof value === 'object' && value !== null) {
        if (value.message) {
          messages.push({
            field: `${prefix}${key}`,
            message: idx > 0 ? `${value.message} (row ${idx})` : value.message,
          });
        } else {
          messages = [
            ...messages,
            ...collectErrors(value, `${prefix}${key}.`, idx),
          ];
        }
      }
    });

    return messages;
  };

  const formStateErrors = collectErrors(errors);

  if (formStateErrors && formStateErrors.length > 0) {
    return (
      <Alert sx={{ mb: 2, mt: -1 }} severity="error">
        <AlertTitle>
          {formatMessage({
            id: 'FORM_ERRORS',
            defaultMessage: 'Form Errors',
          })}
        </AlertTitle>
        <ul>
          {formStateErrors.map(error => (
            <li key={`${error?.field}${error?.message}`}>{error?.message}</li>
          ))}
        </ul>
      </Alert>
    );
  }

  return null;
}

export function FormErrors({ errors, parentKey = '' }) {
  if (!errors || typeof errors !== 'object') return null;

  return (
    <ul>
      {Object.entries(errors).map(([key, value]) => {
        const path = parentKey ? `${parentKey}.${key}` : key;

        if (
          value &&
          typeof value === 'object' &&
          !Array.isArray(value) &&
          'message' in value &&
          typeof value.message === 'string'
        ) {
          return (
            <li key={path}>
              {path}: {value.message}
            </li>
          );
        }

        if (typeof value === 'object') {
          return (
            <li key={path}>
              <FormErrors errors={value} parentKey={path} />
            </li>
          );
        }

        return (
          <li key={path}>
            {path}: {String(value)}
          </li>
        );
      })}
    </ul>
  );
}

export default FormStateError;
